<template>
    <div>
        <!-- <vue-headful v-bind:title="$t('work-with-us.metadata.title')" v-bind:description="$t('work-with-us.metadata.description')" logLocale="sv_SE" ang="sv-SE"/>  -->

        <Hero img="/images/work-2.jpeg" v-bind:title="$t('work-with-us.hero.title')" v-bind:preamble="$t('work-with-us.hero.preamble')" v-bind:body="$t('work-with-us.hero.body')" />

        <section id="services">
            <div class="container">
                <div class="section-content">
                    <div class="text-area">
                        <h2>{{$t('work-with-us.content.upper.title')}}</h2>
                        <p>{{$t('work-with-us.jobs.text')}}</p>
                        <ul>
                            <li v-for="(data, index) in $t('work-with-us.jobs.items')" :key="index"><router-link v-bind:to=data.url>{{data.text}}</router-link></li>
                        </ul>
                        <p v-for="(data, index) in $t('work-with-us.content.upper.texts')" :key="index">{{data.text}}</p>
                        <div class="card-deck">
                            <Fact v-for="(data, index) in $t('work-with-us.items')" :key="index" :img=data.img :title=data.name :subtitle=data.role :text=data.text :listItems=data.listItems :index=index />
                        </div>
                        <h2>{{$t("work-with-us.content.lower.title")}}</h2>
                        <p>
                            {{$t("work-with-us.content.lower.text-before-phone-link")}}
                            <a href="tel:+46852027650">{{$t("work-with-us.content.lower.phone-link")}}</a>
                            {{$t("work-with-us.content.lower.text-before-form-link")}}
                            <router-link to="/contact">{{$t("work-with-us.content.lower.form-link")}}</router-link>
                            {{$t("work-with-us.content.lower.text-after-form-link")}}
                        </p>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import Fact from '../components/Fact'
    import Hero from '../components/Hero'

    export default {
        name: 'app',
        components: {
            Fact,
            Hero
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
</style>